<template>
    <v-app>
        <v-navigation-drawer app v-model="drawer" temporary>
            <v-list>
            <v-list-item class="px-2">
              <v-list-item-avatar>
                <v-img :src="images.user"></v-img>
              </v-list-item-avatar>
            </v-list-item>

            <v-list-item link>
              <v-list-item-content>
                <v-list-item-title class="title">{{usuario.nome}}</v-list-item-title>
                <v-list-item-subtitle>{{usuario.email}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
            <v-divider />
            <Menu />
        </v-navigation-drawer>

        <v-app-bar app color="darken-2" dense dark absolute height="60">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"/>
            <v-toolbar-title>
              <div style="display:flex">
                <v-img :src="images.logo2MB" style="width:100px;height:auto;" ></v-img>
                <div style="background-color: lightgray;width: 1px;margin-left: 20px;opacity: 0.3;"/>
                <span style="margin-left: 20px;font-size: 14px;margin-top: 5px;">{{titulo_rota}}</span>
              </div>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon style="margin: 10px">
                <v-icon @click="sair">mdi-exit-to-app</v-icon>
            </v-btn>
        </v-app-bar>

        <v-content style="background-color: #f4f5f7!important; margin-top: 10px;">
            <v-container fluid>
              <router-view></router-view>
            </v-container>
        </v-content>

        <!--
        <v-footer :inset="true" app>
            <span class="px-4">&copy; {{ new Date().getFullYear() }} Ideias Mobile</span>
        </v-footer> -->
    </v-app>
</template>

<script>
//import { USUARIO_LOGADO } from "@/utils/constants.js";
import Menu from "./Menu.vue"
export default {
    data () {
      return {
        drawer: null,
        titulo_rota: null,
        items: [
          { title: 'Colunas', icon: 'mdi-view-dashboard' },
          { title: 'Podcast', icon: 'mdi-image' },
        ],
        images: {
            logo2MB: require('../assets/mb_logo.png'),
            menuMB: require('../assets/photo_mb_menu.png'),
            user: require('../assets/round_supervised_user_circle_black_18dp.png')
        },
        usuario:  {}
      }
    },
    components: {
      Menu
    },
    methods: {
        sair() {
          this.$store.dispatch('usuario/logout')
          location.reload();
        }
    },
    mounted(){
      this.usuario = this.$store.getters['usuario/getUsuario'];
      this.$Progress.finish()
    },
    created () {
      this.$vuetify.theme.dark = false
      this.$Progress.start()
      this.$router.beforeEach((to, from, next) => {
        if (to.meta.progress !== undefined) {
          let meta = to.meta.progress
          this.$Progress.parseMeta(meta)
        }
        this.$Progress.start()
        next()
      })
      this.$router.afterEach(() => {
        this.$Progress.finish()
      })
    },
    updated(){
      this.titulo_rota = this.$router.currentRoute.name
    },
};
</script>

<style>
#app {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100vw;
  height: 100vh;
}

.sair {
  float: right;
}
</style>